module.exports = __webpack_public_path__ + "img/Saint-Barthelemy.df54a4d0.png";